import ConfigurationItemRow from "features/configuration/GeneralConfiguration/ConfigurationItem/ConfigurationItemRow";
import { useContext, useEffect, useState } from "react";
import {
  GeneralConfigurationContext,
  ModalItemContext,
} from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import { useConfigurationItem } from "features/configuration/GeneralConfiguration/ConfigurationItem";
import Select from "common/Select/Select";
import { getOptionText } from "features/configuration/GeneralConfiguration/utils";
import styled from "styled-components";
import { DrawerContext } from "common/Drawers/Drawer.context";

const WheelItem = ({ item, inCombinedItem }) => {
  const {
    itemValue,
    handleItemChange,
    itemName,
    itemOptions,
    prefix,
    suffix,
    itemShouldDisplay,
    overrideComponent,
    itemValueModified,
    addOptionToItem,
    uuid,
  } = useConfigurationItem({ item });
  const { inModal } = useContext(ModalItemContext);
  const { editable, useDefaultPopupContainer } = useContext(
    GeneralConfigurationContext
  );
  const [initialRender, setInitialRender] = useState(true);

  const firstItemOption = itemOptions?.[0];
  useEffect(() => {
    if (itemOptions?.length) {
      const valuePresentInOptions = itemOptions?.find(
        (option) => option.value === itemValue
      );
      if (initialRender && itemValue && !valuePresentInOptions) {
        addOptionToItem(itemValue);
      } else if (!initialRender || (!valuePresentInOptions && !itemValue)) {
        handleItemChange(firstItemOption.value);
      }
    }
    if (initialRender) setInitialRender(false);
  }, [itemOptions]);

  let extraInfoComponent;
  if (editable) {
    extraInfoComponent =
      itemShouldDisplay || inCombinedItem ? (
        <WheelItemSelect
          itemValue={itemValue}
          handleItemChange={handleItemChange}
          itemOptions={itemOptions}
          prefix={prefix}
          suffix={suffix}
          disabled={!itemShouldDisplay}
          popupContainerId={
            inCombinedItem || useDefaultPopupContainer ? undefined : uuid
          }
        />
      ) : null;
  } else {
    let itemOption = itemOptions?.find((option) => option.value === itemValue);

    if (!itemOption) {
      // todo: handle case where item value is not the same as item display name
      itemOption = { name: itemValue, value: itemValue };
    }

    extraInfoComponent = getOptionText(
      itemValue,
      prefix,
      itemOption,
      suffix,
      ""
    );
  }

  const itemNameToWarning = {
    "number of orders":
      "Can't change number of orders when using a custom strategy",
  };

  const overridePlaceholder = inModal ? null : <span />;

  return (
    <ConfigurationItemRow
      nameComponent={inCombinedItem ? null : itemName}
      extraInfoComponent={extraInfoComponent}
      overrideComponent={overrideComponent || overridePlaceholder}
      itemValueModified={!inCombinedItem && itemValueModified}
      extraInfoAlignRight={inModal}
      inactive={!itemShouldDisplay}
      expandExtraInfoOnClickRow={true}
      wrapperId={uuid}
      errorMessage={
        !itemShouldDisplay && itemNameToWarning[itemName?.toLowerCase()]
      }
    />
  );
};

export default WheelItem;

const WheelItemSelect = ({
  itemValue,
  handleItemChange,
  itemOptions,
  prefix,
  suffix,
  width,
  disabled,
  expanded,
  setExpanded,
  popupContainerId,
}) => {
  const { inModal } = useContext(ModalItemContext);
  const { isDrawer } = useContext(DrawerContext) || {};
  const [localIsOpen, setLocalIsOpen] = useState(expanded);

  useEffect(() => {
    setLocalIsOpen(expanded);
  }, [expanded]);

  const onVisibleChange = (isOpen) => {
    const isControlledFromOutside = typeof expanded === "boolean";
    if (!isControlledFromOutside) {
      setLocalIsOpen(isOpen);
    } else if (!isOpen) {
      setExpanded(isOpen);
    }
  };

  const style = {};
  if (width) {
    style.width = width;
  } else {
    style.minWidth = 40;
  }
  return (
    <StyledSelect
      $isDrawer={isDrawer && !inModal}
      value={itemValue}
      style={style}
      onChange={handleItemChange}
      bordered={false}
      popupMatchSelectWidth={false}
      flushPaddingLeft={true}
      disabled={disabled}
      onOpenChange={onVisibleChange}
      open={localIsOpen}
      getPopupContainer={
        popupContainerId
          ? () => document.getElementById(popupContainerId)
          : undefined
      }
    >
      {(itemOptions || []).map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {getOptionText(option.value, prefix, option, suffix, " ")}
        </Select.Option>
      ))}
    </StyledSelect>
  );
};

const StyledSelect = styled(Select)`
  .ant-select-selector {
    padding-right: 0 !important;
    ${(p) =>
      p.$isDrawer &&
      `
      background-color: ${p.theme.colors.layoutBgColor} !important;
    `};
  }
  .ant-select-arrow {
    inset-inline-end: 0;
  }
  .ant-select-selection-item {
    padding-inline-end: 20px !important;
  }
`;
